export default __webpack_public_path__ + "static/ruchi-b0ac8f520fa99244899721268932f503.jpg";